import Vue from 'vue';
import VuejsDialog from 'vuejs-dialog';

Vue.use(VuejsDialog);



// WEBPACK FOOTER //
// ./src/addons/dialog.js